module.exports = __webpack_public_path__ + "img/z-about-img3.c9237415.jpg";